<template>
    <b-container fluid style="background-color:#e8eff9">
        <PortalNavbar></PortalNavbar>
        <!-- <b-alert variant="danger" :show="dismissCountDown"
             dismissible  @dismissed="dismissCountDown=0"
             @dismiss-count-down="countDownChanged">
             <Notice></Notice>
        </b-alert> -->

            <b-row class="mt-5">
                <b-col>
                </b-col>
                <b-col md="3">
                    <!-- <div class="microsoft containerx">
                        <p class="marquee">Windows 8 and Windows RT are focused on your life—your friends and family, your apps, and your stuff. With new things like the <a href="http://windows.microsoft.com/en-US/windows-8/start-screen">Start screen</a>, <a href="http://windows.microsoft.com/en-US/windows-8/charms">charms</a>, and a <a href="http://windows.microsoft.com/en-US/windows-8/microsoft-account">Microsoft account</a>, you can spend less time searching and more time doing.</p>
                    </div> -->
                    <div>
                                    <div class="login-box-inner">
                                        <h6>Login</h6>
                                        <hr style="margin-top:0.5rem;margin-bottom:0.5rem;"/>
                                        <b-row>
                                            <b-col>
                                                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                                                    <b-alert :show = "showDismissibleAlert" dismissible 
                                                        @dismissed="showDismissibleAlert=false"
                                                        :variant="variant">
                                                        {{alertText}}
                                                    </b-alert>
                                                <div class="form-group">
                                                    <small for="exampleInputEmail1">User Name</small>
                                                    <b-input type="text" :formatter="format"  lazy-formatter v-model="form.userName" required class="form-control" size="sm" id="inputUserID" aria-describedby="emailHelp" placeholder="Enter Your UserName"></b-input>
                                                </div>

                                                <div class="form-group">
                                                    <small for="exampleInputEmail1">Password</small>
                                                    <b-input type="password" :formatter="format"  lazy-formatter v-model="form.Password" class="form-control" size="sm" id="inputPwd" aria-describedby="emailHelp" placeholder="Enter Password"></b-input>
                                                </div>
                                                <div class="form-group">
                                                  <small for="exampleInputEmail1" class="label-text">
                                                    Please following type and click <i class="fa fa-check"></i> key
                                                    <span>*</span>
                                                  </small>
                                                  <captcha
                                                    :callSuccess="captchaOk"
                                                    color="black"
                                                    resolve="text"
                                                    :isAuth="auth"
                                                  ></captcha>
                                                </div>
                                                 <div style="text-align: center">
                                                <b-button
                                                variant="primary"
                                                size="lg"
                                                class="mt-3"
                                                type="submit"
                                                >
                                                Login
                                                </b-button>
                                            </div>
                                                <!-- <div >
                                                    <button class="btn btn-primary btn-lg float-right" 
                                                   
                                                    type="submit">Login</button>
                                                </div> -->
                                                <!-- <div>
                                                    <b-btn variant="link" size="sm" class="float-right" @click="showModal">Forgot Password</b-btn>
                                                </div> -->
                                                
                                                </b-form>
                                                <!-- <div style="text-align:center;margin-top:60px;" v-if="EventCount>0">
                                                    <b-btn variant="link" size="sm" to="/signup/all">New User? Signup Now</b-btn>
                                                </div>
                                                  <div style="text-align:center;margin-top:60px;" >
                                                    <b-btn variant="link" size="sm" to="/signup/all">New User ?</b-btn>
                                                </div> -->
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                </b-col>
                <b-col></b-col>
            </b-row>
       
        <b-modal ref="myModalRef" title="Forgot Password?" hide-footer >
            <ForgotPassword @close="hideModal()"></ForgotPassword>
        </b-modal>
    </b-container>
</template>

<script>
import apis from "@/apis";
import ForgotPassword from "@/components/ForgotPassword";
import captcha from "@/components/Captcha.vue"; //change the path as per your project
import PortalNavbar from "@/components/PortalNavbar";
import Notice from "@/components/Notice";

export default {
  components: { PortalNavbar, ForgotPassword, Notice, captcha },
  data() {
    return {
      auth: false,
      dismissSecs:20,
      dismissCountDown: 0,
      form: {
        userName: "",
        Password: ""
      },
      slide: 0,
      sliding: null,
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false
    };
  },
  methods: {
    captchaOk() {
      this.auth = true;
      
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = true;
    },
    getImgUrl(pic) {
      return require("../assets/" + pic);
    },
    onSubmit(evt) {
      if (!this.auth) {
    this.$dialog.alert("Please enter Captcha");
    return false;
}
      evt.preventDefault();
      this.isLoading = true;
      this.showDismissibleAlert = false;

      let promise = apis.login(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            let userary = response.body;
            if (userary.length == 0) {
              this.alertText = "User name or Password is invalid";

              this.variant = "warning";
              this.showDismissibleAlert = true;
            } else {
              this.$store.dispatch("login", {
                token: response.body[0].SessionID,
                user: response.body[0]
              });
              this.$router.replace("/dashboard");
            }
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset(evt) {}
  },
  mounted(){
      this.dismissCountDown = this.dismissSecs
  }
};
</script>

<style scoped>
body {
  background: #e8eff9 !important;
}

ul {
  padding: 0;
  margin: 0;
}
.top-land {
  /*border-bottom : solid 2px #ccc;*/
  padding-top: 10px;
  padding-bottom: 10px;
}
.navbar {
  padding: 0 !important;
  background: #5c6bc0 !important;
}
.navbar-brand {
  font-size: 12pt !important;
  color: #ccc !important;
}
.login-box-inner {
  background: #fbfbfb;
  padding: 25px 20px;
  border: solid thin #ddd;
  border-radius: 4px;
  -webkit-box-shadow: 8px 14px 14px -4px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: 8px 14px 14px -4px rgba(0, 0, 0, 0.32);
  box-shadow: 8px 14px 14px -4px rgba(0, 0, 0, 0.32);
}

.nav-item:hover .login-box {
  display: block;
}

.containerx {
  width: 100%;
  height: 95%;
  margin-bottom: 1em auto;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
}

.marquee {
  top: 6em;
  position: relative;
  box-sizing: border-box;
  animation: marquee 15s linear infinite;
}

.marquee:hover {
  animation-play-state: paused;
}

/* Make it move! */
@keyframes marquee {
  0% {
    top: 8em;
  }
  100% {
    top: -11em;
  }
}

/* Make it look pretty */
.microsoft .marquee {
  margin: 0;
  padding: 0 1em;
  line-height: 1.5em;
  font: 1em "Segoe UI", Tahoma, Helvetica, Sans-Serif;
}

.microsoft:before,
.microsoft::before,
.microsoft:after,
.microsoft::after {
  left: 0;
  z-index: 1;
  content: "";
  position: absolute;
  pointer-events: none;
  width: 100%;
  height: 2em;
  background-image: linear-gradient(180deg, #fff, rgba(255, 255, 255, 0));
}

.microsoft:after,
.microsoft::after {
  bottom: 0;
  transform: rotate(180deg);
}

.microsoft:before,
.microsoft::before {
  top: 0;
}
.rounded-circle {
  width: 100%;
  max-width: 200px;
  margin-bottom: 10px;
}
.guidelines {
  background: url(../assets/pdfIcon.png) no-repeat left 1px;
  padding-left: 28px;
  display: block; /* float: left; width: 100%;*/ /* line-height: 22px; */
  margin-left: 5px;
  color: #000 !important;
  margin-bottom: 0.1rem;
  font: 0.8rem "Segoe UI", Tahoma, Helvetica, Sans-Serif;
}
.newsnevents {
  display: block; /* float: left; width: 100%;*/ /* line-height: 22px; */
  margin-left: 5px;
  color: #000 !important;
  margin-bottom: 0.1rem;
  font-size: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginLink.vue